import React from 'react';
import { isNullOrUndefined } from 'rewire-common';
import { Observe } from 'rewire-core';
import { IGridFontSizes, IGridColors } from 'rewire-grid';
import { WithStyle, withStyles } from 'rewire-ui';
import { Theme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from '../ui/Grid';
import AddReasonDialog from './AddReasonDialog';
import TimecardGridModel, { IGridLevelErrors } from './TimecardGridModel';

export type timecardGridHeaderClassKey = 'root';

export const timecardGridHeaderStyles = (_theme: Theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    paddingLeft: '4px',
    marginBottom: '4px',
    flexWrap: 'wrap',
  },
  numberField: {
    maxWidth: '80px',
  },
  textField: {
    flexGrow: 1,
  },
});

export interface ITimecardGridHeaderProps {
  model: TimecardGridModel;
  classes?: any;

  content?: (props: { model: TimecardGridModel; classes?: any }) => JSX.Element | null;
}

type TimecardGridHeaderProps = WithStyle<ReturnType<typeof timecardGridHeaderStyles>, ITimecardGridHeaderProps>;

export const TimecardGridHeader = withStyles(
  timecardGridHeaderStyles,
  class extends React.PureComponent<TimecardGridHeaderProps> {
    constructor(props: TimecardGridHeaderProps) {
      super(props);
    }

    render() {
      const { classes, model } = this.props;

      return (
        <Observe
          render={() =>
            this.props.content ? (
              <this.props.content model={model} classes={{ root: classes.root }} />
            ) : (
              <div className={classes.root}>
                <model.form.field.start.Editor className={classes.numberField} />
                <model.form.field.end.Editor className={classes.numberField} />
                <model.form.field.units.Editor className={classes.numberField} />
                <model.form.field.reason.Editor className={classes.textField} />
              </div>
            )
          }
        />
      );
    }
  },
);

export const timecardGridStyles = (theme: Theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
  },
  gridContainer: {
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
  },
  grid: {},
  gridLevelErrors: {
    display: 'flex',
    flexDirection: 'column',
    color: theme.palette.error.main,
  },
});

export interface ITimecardGridProps {
  model: TimecardGridModel;
  gridColors?: IGridColors;
  gridFontSizes?: IGridFontSizes;
  classes?: any;
}

type TimecardGridProps = WithStyle<ReturnType<typeof timecardGridStyles>, ITimecardGridProps>;

class TimecardGrid extends React.PureComponent<TimecardGridProps> {
  constructor(props: TimecardGridProps) {
    super(props);
  }

  render() {
    const { classes, model, gridColors, gridFontSizes } = this.props;

    return (
      <Observe
        render={() => (
          <div className={classes.root}>
            <div className={classes.gridContainer}>
              <Observe
                render={() =>
                  (!isNullOrUndefined(model.grid.id) && (
                    <Grid
                      key={model.grid.id}
                      grid={model.grid}
                      gridColors={gridColors}
                      gridFontSizes={gridFontSizes}
                      className={classes.grid}
                    />
                  )) ||
                  null
                }
              />
            </div>
            <Observe
              render={() => (
                <Typography variant="body2" className={classes.gridLevelErrors}>
                  {Object.keys(model.gridLevelErrors).map((key: keyof IGridLevelErrors) =>
                    model.gridLevelErrors[key] ? <span key={key}>{model.gridLevelErrors[key]}</span> : null,
                  )}
                </Typography>
              )}
            />
            <AddReasonDialog />
          </div>
        )}
      />
    );
  }
}

export default withStyles(timecardGridStyles, TimecardGrid);
